import Vue from 'vue'
import store from './store'
import StudentExchangePartnerWidget from './StudentExchangePartnerWidget.vue'
import VueCompositionAPI from '@vue/composition-api'
import { getAttributeValue } from "@/shared/filters/utils-filter"

Vue.config.productionTip = false
Vue.use(VueCompositionAPI)

let widgetEls = document.querySelectorAll('student-exchange-partner')

if (widgetEls.length) {
    widgetEls.forEach(el => {
        new Vue({
            el: el,
            store,
            render(h: any) {
                return h(StudentExchangePartnerWidget, {
                    props: {
                        labels: getAttributeValue(el, 'labels', true),
                        programId: getAttributeValue(el, 'programId'),
                        redirectUrl: getAttributeValue(el, 'redirectUrl'),
                        language: getAttributeValue(el, 'language')
                    }
                })
            }
        })
    })
}
